import { ACTION_LOG_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { IActionLogRepository } from "../domain/repositories/IActionLogRepository";
import { ActionLogDetailResponseModel } from "./models/ActionLogDetailResponseModel";
import { ActionLogRequestModel } from "./models/ActionLogRequestModel";
import { ActionLogResponseModel } from "./models/ActionLogResponseModel";

@injectable()
export class ActionLogRepositoryImpl implements IActionLogRepository {
  async getList(
    params: ActionLogRequestModel,
  ): Promise<ListBaseApiResponseModel<ActionLogResponseModel>> {
    return await client?.get(ACTION_LOG_MANAGEMENT.LIST, params);
  }

  async getDetail(
    params: ActionLogRequestModel,
  ): Promise<BaseApiResponseModel<ActionLogDetailResponseModel>> {
    return await client?.get(ACTION_LOG_MANAGEMENT.DETAIL, params);
  }
}
